//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

	props: ['url', 'item'],

	data: function data() {
		return {
			selectedCheck: false,
			disableGenerateButton: false
		};
	},


	methods: {
		viewCheck: function viewCheck(item, idx) {
			//Event.$emit('show-flyout','Check Details','/prototype/accounting/accounts-payable/check/view','ap-view-check')
			if (this.selectedCheck === idx) {
				this.selectedCheck = false;
			} else {
				this.selectedCheck = idx;
			}
		},
		invoice: function invoice(id) {
			return this.item.invoices.find(function (invoice) {
				return invoice.id === id;
			});
		},
		approve: function approve() {
			var _this = this;

			axios.post('/prototype/accounting/accounts-payable/payments/approve', { id: this.item.id }).then(function (response) {
				_this.item = response.data;
				Event.$emit('refresh-payments');
			});
		},
		print: function print() {
			var _this2 = this;

			this.disableGenerateButton = true;
			axios.post('/prototype/accounting/accounts-payable/payments/print', { id: this.item.id }).then(function (response) {
				_this2.item = response.data;
				_this2.disableGenerateButton = false;
				Event.$emit('refresh-payments');
			});
		}
	},

	mounted: function mounted() {},


	computed: {
		total: function total() {
			var total = 0;
			return this.item.checks.reduce(function (total, entry) {
				return total + parseFloat(entry.amount);
			}, total);
		}
	}

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/payments/PaymentDetails.vue
// module id = 7Ykk
// module chunks = 0 1